import React from 'react';
import {
  RequestPasswordResetPage,
  ResetPasswordPage,
  VerifyPasswordResetTokenPage,
} from './components';
import {Route} from 'react-router';

export default (
  <Route>
    <Route path="request-password-reset" component={RequestPasswordResetPage} />
    <Route path="verify-password-reset-token/:userId/:token" component={VerifyPasswordResetTokenPage} />
    <Route path="reset-password/:userId/:token" component={ResetPasswordPage} />
  </Route>
);



// WEBPACK FOOTER //
// ./app/features/passwordManagement/routes.js